/**
 * POST `admin/accounts/:id/block` / `unblock` — отобрать у человека доступ
 * целиком или вернуть. Блокировка действует сразу: все сессии гасятся,
 * выданный токен получает 403. Разблокировка сессий не восстанавливает.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_ACCOUNTS} from '../mocks';

export type BlockAccountInput = {id: string; reason: string};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

const patchMock = (id: string, blocked: boolean, reason: string | null) => {
  const a = MOCK_ACCOUNTS.find((x) => x.id === id);
  if (!a) return;
  a.blocked = blocked;
  a.blockedAt = blocked ? new Date().toISOString() : null;
  a.blockedReason = reason;
};

export const blockAccount = async (input: BlockAccountInput): Promise<void> => {
  const reason = input.reason.trim() !== '' ? input.reason.trim() : null;
  if (!apiEnabled) {
    await sleep(350);
    patchMock(input.id, true, reason);
    return;
  }
  await http(`admin/accounts/${encodeURIComponent(input.id)}/block`, {
    method: 'POST',
    body: {reason},
    skipCaseConversion: true,
  });
};

export const unblockAccount = async (id: string): Promise<void> => {
  if (!apiEnabled) {
    await sleep(300);
    patchMock(id, false, null);
    return;
  }
  await http(`admin/accounts/${encodeURIComponent(id)}/unblock`, {
    method: 'POST',
    skipCaseConversion: true,
  });
};
